import { useContext } from 'react';
import { debuggerState } from '../providers';

const useDebuggerState = () => {
  const context = useContext(debuggerState);
  if (!context) {
    throw new Error('context not initialized');
  }
  return context;
};

export default useDebuggerState;
